<template>
<div class="oh allchain" >
	<leftnav itemcode="E-DBQY" ></leftnav>
	<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''" style="height: 100vh;overflow-y: scroll;" >
		<!-- -->
		<govheader></govheader>
		<div class="index_left_centerpage">  
		<div class="whitebox right_topbox">
			<div class="right_boxtitle">
				<span class="fl right_title">{{title}}</span>  
				<span class="fr lh36 curp mr-3" @click="routerself('/enterprise-compare-records')">对比记录</span>
				<span class="fr basebtn chanyeshezhi mr-3" v-show="isCreate" @click="saveEnterpriseComparison">保存结果</span>
				<!-- <span class="btnbox fr" @click="openAddSearch">添加企业</span> -->
			</div> 
		</div>  
		<!-- 对比企业标题 -->
		<div class="compare-view-scroll industrialPie">
			<table  border="0" cellspacing="0" cellpadding="0"  width="100%" class="top-sticky">
			<tr class="compare-view compare-top-title ">
				<th class="a-compare-company left-sticky">
					<h3 class="title">对比城市</h3>
				</th>
				<th class="a-compare-company has-company-data por" v-for="(list,i) in compare_list" :key="i">
					 <h4 class="smtitle tac">{{list.title}}</h4>
						<span class="delete-icon border-dashed" @click="deleteItem(list)" v-show="isCreate"><i class="el-icon el-icon-close"></i></span>
						<p class="move-compare tac">
							<em  :class="i == 0 ?'el-icon el-icon-arrow-left col999':'el-icon el-icon-arrow-left cur-pointer'"  @click="moveCompare('prev',list,i,i == 0)"></em>
							移动对比
							<em :class="i == (compare_list.length-1) ?'el-icon el-icon-arrow-right col999':'el-icon el-icon-arrow-right cur-pointer'" :style="i == (compare_list.length-1) ? 'color:#999':'cursor:pointer'" @click="moveCompare('next',list,i,i == (compare_list.length-1))"></em>
						</p>
				</th>
				<th class="a-compare-company " v-for="(item,index) in  4-compare_list.length" :key="index+10">
					<div class="compare-empty-company"  @click="openAddSearch" v-show="isCreate">
						<span class="add-icon"><i class="el-icon el-icon-plus"></i></span>
						<p>添加城市</p>
					</div> 
				</th>
			</tr> 
			</table>
		<!-- 企业分布饼图 -->
		<industrialDistribution :compareList="compare_list" :refreshNum="listRefresh" id="qyfb"></industrialDistribution>
		<!-- 基本信息 -->
		<!-- <baseinforBlock :compareList="compare_list" :refreshNum="listRefresh" id="jbxx"></baseinforBlock> -->
		<!-- 招商画像 -->
		<!-- <zhaoshanghuaxiang :compareList="compare_list" :refreshNum="listRefresh" id="zshx"></zhaoshanghuaxiang> -->
		<!-- 实力标签 -->
		<!-- <shilibiaoqian :compareList="compare_list" :refreshNum="listRefresh" id="slbq"></shilibiaoqian> -->
		<!-- 经营状况 -->
		<!-- <jingyingzhuangkuang :compareList="compare_list" :refreshNum="listRefresh" id="jyzk"></jingyingzhuangkuang> -->
		<!-- 融资信息 -->
		<!-- <rongzixinxi :compareList="compare_list" :refreshNum="listRefresh" id="rzxx"></rongzixinxi> -->
		<!-- 供应商 -->
		<!-- <gongyingshang :compareList="compare_list" :refreshNum="listRefresh" id="gys"></gongyingshang> -->
		<!-- 客户 -->
		<!-- <kehu :compareList="compare_list" :refreshNum="listRefresh" id="kehu"></kehu> -->
		<!-- 拿地信息 -->
		<!-- <nadixinxi :compareList="compare_list" :refreshNum="listRefresh" id="ndxx"></nadixinxi> -->
		<!-- 投资项目 -->
		<!-- <touzixiangmu :compareList="compare_list" :refreshNum="listRefresh" id="tzxm"></touzixiangmu> -->
		<!-- 融资项目 -->
		<!-- <rongzixiangmu :compareList="compare_list" :refreshNum="listRefresh" id="rzxm"></rongzixiangmu> -->
		<!-- 对外投资 -->
		<!-- <duiwaitouzi :compareList="compare_list" :refreshNum="listRefresh" id="dwtz"></duiwaitouzi> -->
		<!-- 控制企业 -->
		<!-- <kongzhiqiye :compareList="compare_list" :refreshNum="listRefresh" id="kzqy"></kongzhiqiye> -->
		<!-- 科技实力 -->
		<!-- <kejishili :compareList="compare_list" :refreshNum="listRefresh" id="kjsl"></kejishili> -->
		<!-- 风险信息 -->
		<!-- <fengxianxinxi :compareList="compare_list" :refreshNum="listRefresh" id="fxxx"></fengxianxinxi>   -->
		<div style="height: 200px;width: 100%;"></div>
		</div>
		<!-- 添加企业弹框 -->
		<!-- 	@togEnterpriseComparison="togEnterpriseComparison"
		@getSingleEnterInfor="getSingleEnterInfor" -->
		<addSearchPop
		:oldList="compare_list_pop" 
		@deleteItem="deleteItem"  
		@getAddResults="getAddResults"
		v-if="isCreate"
		:refreshNum="refreshNum"
		ref="addsearchpop"
		@getAddEnterpriselist="getAddEnterpriselist">
		</addSearchPop>
	</div>
	</div>
</div>
</template> 
<script> 
import addSearchPop from './inc-table/add-search.vue'
import industrialDistribution from "./inc-table/industrial-distribution"
// import baseinforBlock from "./inc-table/baseinfor-block.vue"
// import zhaoshanghuaxiang from "./inc-table/zhaoShangHuaXiang.vue"
// import shilibiaoqian from "./inc-table/shiLiBiaoQian.vue"
// import jingyingzhuangkuang from "./inc-table/jingYingZhuangKuang.vue"
// import rongzixinxi from "./inc-table/rongZiXinXi.vue"
// import gongyingshang from "./inc-table/gongYingShang.vue"
// import kehu from "./inc-table/keHu.vue"
// import nadixinxi from "./inc-table/naDiXinXi.vue"
// import touzixiangmu from "./inc-table/touZiXiangMu.vue"
// import rongzixiangmu from "./inc-table/rongZiXiangMu.vue"
// import duiwaitouzi from "./inc-table/duiWaiTouZi.vue"
// import kongzhiqiye from "./inc-table/kongZhiQiYe.vue"
// import kejishili from "./inc-table/keJiShiLi.vue"
// import fengxianxinxi from "./inc-table/fengXianXinxi.vue"
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
	  name: 'enterpriseCompareTable',
	  computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
			data(){return{ 
				title:"政策对比",
				userdata:{},  
				compare_list:[
					{stockCode:"300750",title:"上海市",baseinfor:{},
					industy:[
						{ value: 1048, name: 'Search Engine' },
						{ value: 735, name: 'Direct' },
						{ value: 580, name: 'Email' },
						{ value: 484, name: 'Union Ads' },
						{ value: 300, name: 'Video Ads' }]
					},
					{stockCode:"300750",title:"北京市",baseinfor:{},
					industy:[
						{ value: 1048, name: 'Search Engine' },
						{ value: 735, name: 'Direct' },
						{ value: 580, name: 'Email' },
						{ value: 484, name: 'Union Ads' },
						{ value: 300, name: 'Video Ads' }]
					},
					{stockCode:"300750",title:"天津市",baseinfor:{},
					industy:[
						{ value: 1048, name: 'Search Engine' },
						{ value: 735, name: 'Direct' },
						{ value: 580, name: 'Email' },
						{ value: 484, name: 'Union Ads' },
						{ value: 300, name: 'Video Ads' }]
					},
					 
				],
				temporary_compare_list:[],//暂时存放 
				compare_empty_list:[],
				compare_list_pop:[], 
				refreshNum:1,
				listRefresh:1,
				editBool:false,//是否有增加删除
				isComfirm:true,//点击编辑框后是取消还是确认
				isCreate:true,//是否有创建功能 会有记录详情
				isDefault:true,//是否有用户在详情页添加的 删除时不一样
				isDelete:true,//是否有删除操作 如果有
			}},
			components:{
				addSearchPop,industrialDistribution
				// baseinforBlock,zhaoshanghuaxiang,shilibiaoqian,jingyingzhuangkuang,rongzixinxi,gongyingshang,kehu,
				// nadixinxi,touzixiangmu,rongzixiangmu,duiwaitouzi,kongzhiqiye,kejishili,fengxianxinxi
			},
			//监听路由变化、newVal：目标路由，oldVal:原路由，路由不同时重新请求数据
			watch: {
				$route: function(newVal, oldVal) {
					 this.mountedFun();
				}
			},
			created(){  
				this.$nextTick(() => {
						// 禁用右键
						document.oncontextmenu = new Function("event.returnValue=false");
						// 禁用选择
						document.onselectstart = new Function("event.returnValue=false");
				});
				this.userdata = this.getuseriformation(); 
			},
			mounted() {
				// this.mountedFun();
				// this.getSingleEnterCode('add1',300750,'宁德时代新能源科技股份有限公司');
			},
			methods: { 
				//mouted或者变化路由时执行
				mountedFun(){
					this.id = this.$route.query.id;
					this.isCreate=!this.id;
					if(this.id){
						this.getCompareRecordList(this.id);
					}else{
						this.getDefaultEnterpriseList();
						this.compare_list=[];this.temporary_compare_list=[];
					}
				},
				//增加后需要将内容上传到后台并调取相应的详情信息
				getAddResults(codelist,type){
					var requests=[],requests2=[],that=this;
					that.bus.$emit('loading',true); 
					codelist.forEach(code=>{ 
						requests.push(this.$axios.get(this.$api.cyl.enterpriseComparison.entInfo({stockCode:code})))
						// requests2.push(this.$axios.post(this.$api.cyl.enterpriseComparison.addEnterprise({stockCode:code})))
					});  
					Promise.all(requests).then(response => { 
						response.forEach(res=>{
							if(res.data.success){
								var testRadarList=[{value:'-'},{value:'-'},{value:'-'},{value:'-'},{value:'-'}];
								var codeInfor={stockCode:res.data.data.baseinfo.stockCode,title:res.data.data.baseinfo.title,data:res.data.data};
								codeInfor.data.radarList=codeInfor.data.radarList.length<1?testRadarList:codeInfor.data.radarList;
								codeInfor.data.tagList=that.getTagList(codeInfor.data.baseinfo.tag,codeInfor.data.baseinfo.tagCode);
								that.temporary_compare_list.push(codeInfor);  
							}else{
								that.$message({type:'error',message:res.data.msg});
							} 
						}) 
						that.compare_list=that.temporary_compare_list;
						that.bus.$emit('loading',false); 
					});
					if(type == 'add'){
						codelist.forEach(code=>{ 
							requests2.push(this.$axios.post(this.$api.cyl.enterpriseComparison.addEnterprise({stockCode:code})))
						});   
						Promise.all(requests2).then(response => { 
								console.log(response);
							var successA=true,msgtext="添加成功",msgtype='success';
							response.forEach(res=>{
								if(!res.data.success){
									msgtype='warning';
									msgtext=res.data.msg;
								}  
							}); 
							that.$message({type: msgtype,message: msgtext});
						});
					}  
				},
				//如果是创建页面 进入页面时需要先获取用户在企业详情页已加入的企业列表信息
				getDefaultEnterpriseList(){
					var that=this;this.isDefault=true;
					this.$axios.get(this.$api.cyl.enterpriseComparison.enterpriseList(), {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) {
						if(res.data.success){
							console.log('获取用户在企业详情页已加入的企业列表信息',res.data);
							that.getAddResults(res.data.list,'default');
							// for(var i=0;i<res.data.list.length;i++){
							// 	that.getSingleEnterCode('default',res.data.list[i],'');
							// } 
						}else{
							that.$message({type:'error',message:res.data.msg});
						} 
						// that.bus.$emit('loading',false); 
					})  
				},
				//获取对比记录详细信息
				getCompareRecordList(id){
					var that=this;
					that.bus.$emit('loading',true);
					this.$axios.get(this.$api.cyl.enterpriseComparison.detail({id:id}), {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) {
						if(res.data.success){
							var listcl=[];
							var testRadarList=[{value:'-'},{value:'-'},{value:'-'},{value:'-'},{value:'-'}];
							for(var i=0;i<res.data.list.length;i++){
								var smlist={title:res.data.list[i].baseinfo.title,stockCode:res.data.list[i].baseinfo.stockCode,data:res.data.list[i]};
								smlist.data.radarList=smlist.data.radarList.length<1?testRadarList:smlist.data.radarList;
								smlist.data.tagList=that.getTagList(smlist.data.baseinfo.tag,smlist.data.baseinfo.tagCode);
								listcl.push(smlist);
							} 
							// var codeInfor={stockCode:code,title:title,data:res.data.data}; 
							that.compare_list=listcl;that.temporary_compare_list=listcl;
							console.log('记录id详情页',that.compare_list)
							that.listRefresh++;
						}else{
							that.$message({type:'error',message:res.data.msg});
						} 
						that.bus.$emit('loading',false);
						
					})
				},
				//保存对比记录
				saveEnterpriseComparison(){
					// var codelist=[];
					// for(var i=0;i<this.compare_list.length;i++){
					// 	codelist.push(this.compare_list[i].stockCode)
					// }
					var codelist=this.compare_list.map(list=>{
						return list.stockCode;
					});
					var that=this;
					let querydata={stockCodeList:codelist.join(',')};
					$.ajax({
						type:"POST",
						url:this.$api.cyl.enterpriseComparison.save(),
						data:querydata,
						headers:{AuthToken:this.userdata.token },
						success:function(res){  
							that.$message({type:res.success?'success':'error',message:res.success?'保存成功，后期可在对比记录中查看':res.msg}) 
						} 
					});
				},
				//打开添加按钮
				openAddSearch(){
					this.refreshNum++;
					let arry1=[];
					this.compare_list.forEach(list=>{
						 arry1.push({stockCode: list.stockCode,
								title: list.title,
								ischecked: false,})
					});
					this.compare_list_pop=arry1;
					this.isComfirm=false;
					this.isDelete=false;
					this.$refs['addsearchpop'].open=true;
				},
				//添加单个公司 不要时间差了 会有数据混乱 废弃
				getSingleEnterInfor(code){
					var that=this;
					this.bus.$emit('loading',false); 
					this.$axios.get(this.$api.cyl.enterpriseComparison.entInfo({stockCode:code}), {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) {
						if(res.data.success){
							var testRadarList=[{value:'-'},{value:'-'},{value:'-'},{value:'-'},{value:'-'}];
							var codeInfor={stockCode:code,title:res.data.data.baseinfo.title,data:res.data.data};
							codeInfor.data.radarList=codeInfor.data.radarList.length<1?testRadarList:codeInfor.data.radarList;
							codeInfor.data.tagList=that.getTagList(codeInfor.data.baseinfo.tag,codeInfor.data.baseinfo.tagCode);
							that.temporary_compare_list.push(codeInfor); 
							that.compare_list=that.temporary_compare_list;
							that.bus.$emit('loading',true); 
						}else{
							that.$message({type:'error',message:res.data.msg});
						} 
					})
				},
				//添加框里选择公司时同步获取信息 缩短时间差 废弃
				getSingleEnterCode(editType,code,title){ 
					var that=this; 
						that.editBool=true;
						that.isComfirm=false; 
						this.$axios.get(this.$api.cyl.enterpriseComparison.entInfo({stockCode:code}), {
							headers: {
								AuthToken: this.userdata.token
							}
						}).then(function(res) {
							if(res.data.success){
								var testRadarList=[{value:'-'},{value:'-'},{value:'-'},{value:'-'},{value:'-'}];
								var codeInfor={stockCode:code,title:res.data.data.baseinfo.title,data:res.data.data};
								codeInfor.data.radarList=codeInfor.data.radarList.length<1?testRadarList:codeInfor.data.radarList;
								codeInfor.data.tagList=that.getTagList(codeInfor.data.baseinfo.tag,codeInfor.data.baseinfo.tagCode);
								that.temporary_compare_list.push(codeInfor); 
								that.editBool=false;
								that.bus.$emit('loading',that.editBool); 
								var aaa=that.temporary_compare_list;
								if(that.isComfirm || editType == 'default'){ 
									that.compare_list=aaa;
								} 
							}else{
								that.$message({type:'error',message:res.data.msg});
							} 
						}) 
				},
				//增加 、移除企业对比
				togEnterpriseComparison(type,code,fun){ 
					var ajaxurl=type == 'add' ? this.$api.cyl.enterpriseComparison.addEnterprise() : this.$api.cyl.enterpriseComparison.deleteEnterprise();
					let ajaxdata={stockCode:code},that=this; 
				 $.ajax({
				 	type:"POST",
				 	url:ajaxurl,
				 	data:ajaxdata,
				 	headers:{AuthToken:this.userdata.token },
				 	success:function(res){ 
							if(fun)fun(res); 
				 	} 
				 })  
				},
				//删除列表信息
				deleteItem(item){
					var that=this;
					this.togEnterpriseComparison('delete',item.stockCode,function(res){
								if(res.success){
									that.deleteItemSuccess(item);  
								}else{
									that.$message({type: 'warning',message: res.msg,});
								} 
					}); 
				},
				getAddEnterpriselist(data,editType){
					this.bus.$emit('loading',this.editBool);
					this.isComfirm=true;
					var aaa=this.temporary_compare_list;
					this.compare_list=aaa; 
					// if(editType == 'add'){
					// 	this.compare_list=data;
					// 	this.$message({type:'success',message:'添加成功，正在获取数据'}); 
					// 	console.log(data);
					// }else if(editType == 'delete'){
					// 	this.$message({type:'success',message:'编辑成功'});
					// 	let arry1=[],arry2=this.compare_list;
					// 	data.forEach(list=>{
					// 		this.compare_list.forEach(item=>{
					// 			if(item.stockCode == list.stockCode){
					// 				arry1.push(item);
					// 			}
					// 		})
					// 	});
					// 	this.compare_list=arry1; 
					// }
					
				},
				//将实力标签分化城市三个综合实力 技术实力 投资实力
				getTagList(tag,tagcode){
					var tagarrylist=[
					{name:"综合实力",taglist:[],
					children:['2021全球独角兽','世界500强（内资）','世界500强（外资）','中国500强','央企','国有企业','中国民营企业500强','中国制造业民营企业500强',
					'中国服务业民营企业500强','重点企业','标杆企业','知名企业','猎豹企业','独角兽企业','瞪羚企业','雏鹰企业','隐形冠军企业','牛羚企业','上市公司','主板上市公司',
					'科创板上市公司','中小板上市公司','创业板上市公司','港股、美股上市公司','北交所上市公司','新上市','预备上市','新三板上市公司','战略性新兴产业领军企业100强',
					'专精特新中小企业','科技小巨人企业','专精特新小巨人企业','创新型企业','科技型中小企业', '民营科技企业','企业技术中心','科技企业孵化器','技术创新示范企业','技术先进型服务企业',
					'省级专精特新企业','省级专精特新小巨人企业','高新技术企业','华为系','字节系','腾讯系','阿里系','百度系','京东系','美团系','小米系']},
					{name:"技术实力",taglist:[],children:['国家科技支撑计划','国家科技重大专项','国家标准起草单位','国家薪火项目','国家级科学技术进步奖','国家地方联合工程研究中心','国家重大科学仪器设备开发专项','国家级工业设计中心','高新技术企业研发中心','企业国家重点实验室','认定企业技术中心','院士专家工作站','博士后工作站','博士后流动站','中国专利奖','研发人员多','研发投入多','研发能力强','专利多','有专利','证书多','有证书','专利质量高']},
				 {name:"投资实力",taglist:[],children:['盈利能力强','偿债能力强','成长能力强','现金流稳健','近期有融资','连续融资','投资意愿强','项目投资数量多','近期有项目投资','有项目投资','连续项目投资','股权投资数量多','近期有股权投资','有股权投资','连续股权投资','拿地面积大','拿地数量多','有拿地','近期有拿地','连续拿地']},	
				];  
				var ddtaglist=this.taglistfun(tag,tagcode);  
				for(var i=0; i<ddtaglist.length;i++){
					let arrts=ddtaglist[i],arrtsname=ddtaglist[i].name;
					for(var d=0;d<tagarrylist.length;d++){
						for(var s=0;s<tagarrylist[d].children.length;s++){
							if(tagarrylist[d].children[s] == arrtsname){
								tagarrylist[d].taglist.push(arrts);
							}
						}
					}  
				} 
					return tagarrylist;
				},
			
				deleteItemSuccess(item){ 
						this.compare_list=this.compare_list.filter(list=>{
							return list.stockCode!=item.stockCode;
						});
						this.temporary_compare_list=this.temporary_compare_list.filter(list=>{
							return list.stockCode!=item.stockCode;
						}); 
					 this.$message({type:'success',message:'删除成功'})
				},
				//点击楼层滚动
				floorScroll(idname){
					const floorName = document.getElementById(idname); 
					if(floorName){
						console.log(idname,floorName,floorName.offsetTop);
						// window.scrollTo(0,floorName.offsetTop)
						document.getElementsByClassName('index_left')[0].scrollTo(0,floorName.offsetTop-240)
						// document.doucementElement.scrollTop(floorName.offsetTop);
						return;
						floorName.scrollIntoView({
								// 滚动到指定节点 
								block: 'start', // 值有start,center,end，nearest，当前显示在视图区域中间 
								behavior: 'smooth', // 值有auto、instant,smooth，缓动动画（当前是慢速的）
						});
					}  
				},
				//移动横向对比
				moveCompare(direct,list,indexs,bool){ 
					if(!bool){
						let movenum=direct == 'prev'?indexs-1:indexs+1; 
						let arry1=[],arry2=[];
						arry1=this.compare_list.filter(item=>{
							return item.stockCode!=list.stockCode;
						})
						if(movenum == arry1.length && direct == 'next'){
							arry1.push(list);
							arry2=arry1;
						}else if(movenum == 0 && direct == 'prev'){
							arry1.unshift(list);
							arry2=arry1;
						}else{
							arry1.forEach((item,i)=>{
								if(i == movenum){
									arry2.push(list); 
								} 
									arry2.push(item);
								 
							})
						} 
						console.log(arry2,movenum);
						this.compare_list=arry2; 
						this.temporary_compare_list=arry2; 
					} 
				},
			},
	}
</script>

<style> 
  
</style>
